////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const modals = {
	[ActionsTypes.HYDRATE_MODAL]: (state, payload) => {
		const translations = state.languages.translations
		const modalInput = payload.data
		const modal = {
			key: translations[modalInput.key],
			title: translations[modalInput.title],
			level: modalInput.level,
			show: modalInput.show,
			path: modalInput.path,
			errorMsgParams: modalInput.errorMsgParams || [],
			insideModalResponse: modalInput.insideModalResponse,
		}
		return update(state, {
			modal: {
				$set: { ...modal },
			},
		})
	},
	[ActionsTypes.CLOSE_MODAL]: (state) => {
		return update(state, {
			user: {
				path: {
					$set: '',
				},
			},
			modal: {
				key: {
					$set: false,
				},
				title: {
					$set: '',
				},
				level: {
					$set: '',
				},
				show: {
					$set: false,
				},
				errorMsgParams: {
					$set: [],
				},
				insideModalResponse: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.CLOSE_MODAL_REDIRECT]: (state) => {
		const path = cloneDeep(state.modal.path)

		return update(state, {
			user: {
				path: {
					$set: path,
				},
			},
			modal: {
				key: {
					$set: false,
				},
				title: {
					$set: '',
				},
				level: {
					$set: '',
				},
				show: {
					$set: false,
				},
				errorMsgParams: {
					$set: [],
				},
				insideModalResponse: {
					$set: false,
				},
			},
		})
	},

	[ActionsTypes.OPEN_TOOLTIP_HELP]: (state, payload) => {
		return update(state, {
			tooltipHelp: {
				showModal: {
					$set: true,
				},
				content: {
					$set: payload.content,
				},
				insideModal: {
					$set: payload.insideModal,
				},
			},
		})
	},
	[ActionsTypes.CLOSE_TOOLTIP_HELP]: (state) => {
		return update(state, {
			tooltipHelp: {
				showModal: {
					$set: false,
				},
				content: {
					$set: '',
				},
				insideModal: {
					$set: false,
				},
			},
		})
	},
}
export default modals
